import { z } from 'zod';

/**
 * Review queue actions (PRD §F5). Every one of these is a human correcting or
 * confirming the matcher, which is why `resolve` carries enough to write a
 * `match_correction` row: the planner's answer is the most valuable training
 * signal this product generates.
 */

export const confirmReviewSchema = z.object({
  /** The inquiry the message actually belongs to. */
  inquiryId: z.string().uuid(),
});

export const dismissReviewSchema = z.object({
  /** Also suppress future queue items from this sender (PRD §F5, undoable). */
  suppressSender: z.boolean().default(false),
});

/** "Create vendor from this sender", then attach the message to an inquiry. */
export const createVendorFromSenderSchema = z.object({
  businessName: z.string().min(1).max(255),
  primaryCategory: z.string().max(100).nullable().optional(),
  /** Attach to this wedding by opening an inquiry for the new vendor. */
  weddingId: z.string().uuid(),
  category: z.string().min(1).max(100),
});

export const bulkConfirmSchema = z.object({
  reviewItemIds: z.array(z.string().uuid()).min(1).max(100),
  inquiryId: z.string().uuid(),
});

export type ConfirmReviewInput = z.infer<typeof confirmReviewSchema>;
export type DismissReviewInput = z.infer<typeof dismissReviewSchema>;
export type CreateVendorFromSenderInput = z.infer<typeof createVendorFromSenderSchema>;
export type BulkConfirmInput = z.infer<typeof bulkConfirmSchema>;
